import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import * as Yup from "yup";
import useGEData from "../../../constants/enum/useGE";
import curriculumService from "../../../services/curriculum.service";
import { createCurri } from "../../../types/curriculum.interface";

const CreateCurriculum = () => {
  const [show, setShow] = useState(false);

  const [useGEList, setUseGEList] = useState<string[]>([]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const CreateCurriculumSchema = Yup.object().shape({
    curriCode: Yup.string(),
    UseGE: Yup.string().required("เลือกรูปแบบด้วยครับ"),
    name: Yup.string()
      .min(2, "อย่างน้อย 2 ตัวอักษร!")
      .max(255, "ไม่เกิน 255 ตัวอักษร!")
      .required("อย่าลืม! กรอกชื่อหลักสูตรด้วยครับ"),
    shortName: Yup.string()
      .min(3, "อย่างน้อย 3 ตัวอักษร")
      .required("กรอกชื่อย่อด้วยครับ"),
    department: Yup.string().required("หลักสูตรนี้อยู่สาขาไหนครับ"),
    level: Yup.string().required("เลือกระดับด้วยครับ"),
    chairman: Yup.string().required(
      "อย่าลืม! กรอกชื่อประธานหลักสูตรหลักสูตรด้วยครับ"
    ),
    headDepartment: Yup.string().required(
      "อย่าลืม! กรอกชื่อหัวหน้าสาขาวิชาหลักสูตรด้วยครับ"
    ),
  });

  const onSubmit = (values: createCurri) => {
    // console.log(values);
    curriculumService
      .create(values)
      .then(() => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "บันทึกสำเร็จ",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          handleClose();
          window.location.reload();
        });
      })
      .catch(() => {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "มีความผิดพลาดบางอย่าง",
          showConfirmButton: false,
          timer: 1500,
        });
      });
  };

  return (
    <>
      <button type="button" className="btn btn-success" onClick={handleShow}>
        <i className="bi bi-folder-plus"></i> เพิ่ม
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        // centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            เพิ่มหลักสูตรใหม่
          </Modal.Title>
        </Modal.Header>
        <Formik
          validationSchema={CreateCurriculumSchema} //กำหนด validation Schema
          initialValues={{
            //กำหนด initialValues
            name: "",
            shortName: "",
            department: "",
            level: "",
            chairman: "",
            headDepartment: "",
            curriCode: "",

            UseGE: "",
          }}
          onSubmit={onSubmit}
          onReset={() => true}
        >
          {({ handleBlur, handleChange, values, errors, touched }) => (
            <Form>
              <Modal.Body>
                <div className="row">
                  <div className="col-4">
                    <label htmlFor="department">ระดับ</label>
                    <select
                      name="level"
                      value={values.level}
                      onChange={(e) => {
                        //ตรงนี้ต้องทำให้รูปแบบเปรียนแปลง
                        switch (e.target.value) {
                          case "ปวช.":
                            setUseGEList(useGEData.level1.useGE);
                            break;
                          case "ปวส.":
                            setUseGEList(useGEData.level2.useGE);
                            break;
                          case "ป.ตรี":
                            setUseGEList(useGEData.level3.useGE);
                            break;
                          case "ป.โท":
                            setUseGEList(useGEData.level4.useGE);
                            break;
                          case "ป.บัณฑิต":
                            setUseGEList(useGEData.level5.useGE);
                            break;
                          default:
                            setUseGEList([]);
                            break;
                        }

                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      className={`form-select ${
                        touched.level
                          ? errors.level
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                      aria-label="Default select example"
                    >
                      <option>ระดับ</option>
                      <option value="ปวช.">ปวช.</option>
                      <option value="ปวส.">ปวส.</option>
                      <option value="ป.ตรี">ปริญญาตรี</option>
                      <option value="ป.โท">ปริญญาโท</option>
                      <option value="ป.บัณฑิต">ประกาศนียบัตรบัณฑิต</option>
                    </select>

                    <ErrorMessage
                      name="level"
                      className="invalid-feedback"
                      component="div"
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="UseGE">รูปแบบ</label>
                    <select
                      name="UseGE"
                      placeholder="รูปแบบ GE"
                      value={values.UseGE}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={`form-select ${
                        touched.UseGE
                          ? errors.UseGE
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                      aria-label="Default select example"
                    >
                      <option value="">รูปแบบ GE</option>
                      {useGEList.map((ge) => {
                        return (
                          <option key={ge} value={ge}>
                            {ge}
                          </option>
                        );
                      })}
                    </select>
                    <ErrorMessage
                      name="UseGE"
                      className="invalid-feedback"
                      component="div"
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col">
                    <label htmlFor="curriCode">รหัสหลักสูตร</label>
                    <Field
                      name="curriCode"
                      className={`form-control ${
                        touched.curriCode
                          ? errors.curriCode
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                      placeholder="รหัสหลักสูตร"
                    />
                    <ErrorMessage
                      name="curriCode"
                      className="invalid-feedback"
                      component="div"
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="shortName">ชื่อย่อ</label>
                    <Field
                      name="shortName"
                      className={`form-control ${
                        touched.shortName
                          ? errors.shortName
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                      placeholder="ชื่อย่อหลักสูตร"
                    />
                    <ErrorMessage
                      name="shortName"
                      className="invalid-feedback"
                      component="div"
                    />
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="col">
                    <label htmlFor="name">ชื่อหลักสูตร</label>
                    <Field
                      name="name"
                      className={`form-control ${
                        touched.name
                          ? errors.name
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                      placeholder="ชื่อหลักสูตร"
                    />
                    <ErrorMessage
                      name="name"
                      className="invalid-feedback"
                      component="div"
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col">
                    <label htmlFor="chairman">ชื่อประธานหลักสูตร</label>
                    <Field
                      name="chairman"
                      className={`form-control ${
                        touched.chairman
                          ? errors.chairman
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                      placeholder="ประธานหลักสูตร"
                    />
                    <ErrorMessage
                      name="chairman"
                      className="invalid-feedback"
                      component="div"
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col">
                    <label htmlFor="department">หน่วยงานรับผิดชอบ</label>
                    <Field
                      name="department"
                      className={`form-control ${
                        touched.department
                          ? errors.department
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                      placeholder="สาขาวิชา"
                    />
                    <ErrorMessage
                      name="department"
                      className="invalid-feedback"
                      component="div"
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col">
                    <label htmlFor="headDepartment">ชื่อหัวหน้าสาขาวิชา</label>
                    <Field
                      name="headDepartment"
                      className={`form-control ${
                        touched.headDepartment
                          ? errors.headDepartment
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                      placeholder="หัวหน้าสาขาวิชา"
                    />
                    <ErrorMessage
                      name="headDepartment"
                      className="invalid-feedback"
                      component="div"
                    />
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button type="submit" className="btn btn-primary">
                  เพิ่มข้อมูล
                </button>
                <button type="reset" className="btn btn-warning">
                  ล้าง
                </button>

                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleClose}
                >
                  Close
                </button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default CreateCurriculum;
